import cn from 'classnames'

type InfoLabelProps = { className?: string }

export const InfoLabel: React.FC<InfoLabelProps> = ({ children, className }) => (
  <dt className={cn('text-sm font-medium text-gray-500', className)}>{children}</dt>
)
